module.exports = __webpack_public_path__ + "static/media/postgresql.12ecc230.png";